export enum EFilesActions {
  GET_LIST_FILE = 'GET_LIST_FILE',
  CREATE_FOLDER = 'CREATE_FOLDER',
  UPLOAD_FILE_MANAGEMENT = 'UPLOAD_FILE_MANAGEMENT',
  DOWNLOAD_FILE_MANAGEMENT = 'DOWNLOAD_FILE_MANAGEMENT',
  DELETE_FILE_MANAGEMENT = 'DELETE_FILE_MANAGEMENT',
}
